/**
 * Represent the products logic and API in the system
 */
class Products {

}

export default new Products()
